import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { LearningOpportunity } from '~/shared/data-contract/learning-opportunities';
import { learningOpportunitySchema } from '~/shared/data-contract/learning-opportunities';

import { learningOpportunityKeys, learningOpportunityPathnames } from './query-keys';

export const useLearningOpportunityQuery = (
    id: string,
    overrideOptions?: Partial<UseQueryOptions<LearningOpportunity, Error>>,
): UseQueryResult<LearningOpportunity, Error> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(learningOpportunitySchema, {
                pathname: learningOpportunityPathnames.detail(id),
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: [...learningOpportunityKeys.details(), learningOpportunitySchema, id],
        throwOnError: false,
        ...overrideOptions,
    });
};
